<template>
    <div class="question-block">
        <div class="question-container">
            <div class="question-bg"><v-icon icon="hearth" /></div>
            <div class="question-image"><img src="/images/question.png" class="lozad" alt=""></div>
            <div class="question-text d-flex align-items-center">
                <div class="container-fluid">
                    <div class="question-text__inner">
                        <div class="question-title">Запитай професійного фармацевта</div>
                        <div class="d-sm-flex question-buttons">
                            <button class="button-white" @click.prevent="askQuestion">Задати питання</button>
                            <inertia-link :href="url" class="button-trans">Як це працює?</inertia-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {},
    computed: {
        url() {
            const slug = this.$page.props.settings?.widget_options?.ask_provisor_howto_page || this.$store.state.settings?.widget_options?.ask_provisor_howto_page;
            return slug ? this.route('frontend.page.index', slug) : this.route('frontend.page.index', 'faq');
        }
    },

    methods: {
        askQuestion() {
            this.$inertia.modal('/ask_provisor')
        },
    }
}
</script>
